import React from 'react';

const StatsCard = ({ title, value, color }) => {
  return (
    <div 
      className="stat-card" 
      style={{ background: `linear-gradient(135deg, ${color} 0%, ${color}dd 100%)` }}
    >
      <div className="stat-number">{value}</div>
      <div className="stat-label">{title}</div>
    </div>
  );
};

export default StatsCard;